"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertionResultFilterSchema = void 0;
exports.buildHasFindingWhere = buildHasFindingWhere;
const QueryBuilder_1 = require("../QueryBuilder");
const design_object_filter_where_1 = require("./design-object-filter-where");
function buildHasFindingWhere(hasFinding) {
    return hasFinding ? { findingLinks: { some: {} } } : { findingLinks: { none: {} } };
}
function buildHasFindingFilterWhere(operator, value) {
    const wantsLinks = operator === 'isNotEmpty' ||
        ((operator === 'is' || operator === 'equals') && value === 'true') ||
        ((operator === 'not' || operator === 'doesNotEqual') && value === 'false');
    const wantsNoLinks = operator === 'isEmpty' ||
        ((operator === 'is' || operator === 'equals') && value === 'false') ||
        ((operator === 'not' || operator === 'doesNotEqual') && value === 'true');
    if (wantsLinks) {
        return { findingLinks: { some: {} } };
    }
    if (wantsNoLinks) {
        return { findingLinks: { none: {} } };
    }
    return {};
}
exports.assertionResultFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        requirementDefinitionId: {
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
            description: 'ID of the parent requirement definition (e.g. cadstrom.eif).',
        },
        assertionDefinitionId: {
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
            description: 'ID of the assertion definition that produced this row.',
        },
        resultSlug: {
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
            description: 'Cross-requirement group identity (e.g. "net:NET_VCC"). Multiple assertion definitions can emit the same slug; they collapse into one UI row.',
        },
        severity: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Result severity.',
        },
        workflowState: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Workflow state.',
        },
        message: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Short user-facing message rolled up from the latest contributing log entry.',
        },
        description: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Long-form description rolled up from the latest contributing log entry.',
        },
        designObject: {
            options: { type: QueryBuilder_1.FieldType.Custom, buildWhere: design_object_filter_where_1.buildDesignObjectWhere },
            allowedOperators: ['is', 'not', 'isAnyOf', 'isNoneOf', 'isEmpty', 'isNotEmpty'],
            description: 'Exact transitive design object linked through the result log entries.',
        },
        hasFinding: {
            options: { type: QueryBuilder_1.FieldType.Custom, buildWhere: buildHasFindingFilterWhere },
            allowedOperators: ['is', 'not', 'equals', 'doesNotEqual', 'isEmpty', 'isNotEmpty'],
            description: 'Whether the assertion result is linked to at least one Requirements V2 finding.',
        },
        continuityKeyType: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Continuity key type.',
        },
        continuityKey: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Opaque continuity value, typed by continuityKeyType.',
        },
        latestLogEntryAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Timestamp of the most recent contributing log entry (sortable).',
        },
        createdAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row creation timestamp.',
        },
        updatedAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row update timestamp.',
        },
    },
});
//# sourceMappingURL=assertion-result-filter-schema.js.map